import { render } from "./SectionPaymentRequestForm.vue?vue&type=template&id=4c6e53b3&scoped=true"
import script from "./SectionPaymentRequestForm.vue?vue&type=script&lang=js"
export * from "./SectionPaymentRequestForm.vue?vue&type=script&lang=js"

import "./SectionPaymentRequestForm.vue?vue&type=style&index=0&id=4c6e53b3&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6e53b3"]])

export default __exports__